import { Stack, Typography } from '@mui/material';

import { Icon } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import type { SelectedCompanyMobileProps } from './types';
import { EditButton } from '../../../HeaderItem/styles';
import { CompanyName } from './styles';

export function SelectedCompanyMobile({
  companyLabel,
  documentLabel,
  onClick,
}: Readonly<SelectedCompanyMobileProps>) {
  return (
    <Stack flexDirection="row" alignItems="center" gap={1}>
      <Stack gap={1}>
        <CompanyName variant="smallText" title={companyLabel}>
          {companyLabel}
        </CompanyName>
        <Typography fontWeight={900} variant="smallText">
          {documentLabel}
        </Typography>
      </Stack>

      <EditButton color="primary" onClick={onClick}>
        <Icon name="actions-b2b-edit" color={NEW_COLORS.PRIMARY[500]} />
      </EditButton>
    </Stack>
  );
}
